import React, { useEffect, useState } from "react";
import { TextField, Typography, Select, MenuItem } from "@material-ui/core";
import "../../Style/Forms.css";
import { Database } from "../../config/config.js";

const Ingresos = (props) => {
  const [categorias, setCategorias] = useState([]);
  const [sueldoBruto, setsueldoBruto] = useState('');
  const [facturacion, setFacturacion] = useState({});
  const sueldo = {
    sueldoBruto: 0,
    facturacionBruta: 0,
  }
  const [formData, setFormData] = useState(sueldo);

  useEffect(() => {
    api()
    return () => {
      setFacturacion()
      setsueldoBruto('')
    }
  }, []);

  const api = async () => {
    apiCategorias()
  };

  const apiCategorias = async () => {
    let newFormData = { ...formData };
    let listCategorias = [];
    await Database.collection("Categorias")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          listCategorias.push(doc.data());
        });
      });
      setCategorias(listCategorias);
      newFormData['monotributo'] = listCategorias[listCategorias.length-1];
    setFormData(newFormData);
    props.sueldoBrutoAnual(newFormData)
    
  }


  const onStatusChangeFacturacion = (event) => {
    let newFormData = { ...formData };
    newFormData['facturacionBruta'] = event.target.value * 12;
    setFormData(newFormData);
    setFacturacion(event.target.value)
    props.sueldoBrutoAnual(newFormData)
  }


  const onStatusChangeSueldo = (event) => {
    let newFormData = { ...formData };
    newFormData['sueldoBruto'] = event.target.value * 13;
    setFormData(newFormData);
    setsueldoBruto(event.target.value)
    props.sueldoBrutoAnual(newFormData)
  }

  const onStatusChangeCategoria = (event) => {
    let newFormData = { ...formData };
    newFormData['monotributo'] = categorias[event.target.value];
    setFormData(newFormData);
    props.sueldoBrutoAnual(newFormData)
  }

  return (
    <div className="Ingresos">
      <div className="Ingresos-Title Title">
        <Typography className="Ingresos-Title__Typography">Ingresos</Typography>
        <Typography className="Ingresos-Subtitle__Typography">Podés ingresar tu sueldo neto como empleado o haber jubilatorio, también la categoría de monotributo en la que estas inscripto o el ingreso como autónomo y tu actividad.</Typography>
      </div>
      <div className="Ingresos_Content  Block">
        <Typography className="Ingresos-Subtitle__Typography">
          En Relación de Dependencia
        </Typography>
        <TextField
          value={sueldoBruto}
          className="Ingresos__TextField"
          id="standard-textarea"
          placeholder="Sueldo Neto Mensual"
          onChange={onStatusChangeSueldo}
          type="number"
        />
      </div>
      <div className="Ingresos_Content Block">
        <Typography className="Ingresos-Subtitle__Typography">
          Monotributo
        </Typography>
        <Select
          className="Ingresos__Select"
          defaultValue={11}
          onChange={onStatusChangeCategoria}
          inputProps={{
            name: "Tipo de Actividad",
            id: "age-native-simple",
          }}
        >
          {!!categorias && categorias.length > 0 &&
            categorias.map((categoria, index) => (
              <MenuItem key={index} value={index}>
                {categoria.Monotributo}
              </MenuItem>
            ))}
        </Select>
      </div>
      <div className="Ingresos_Content">
        <Typography className="Ingresos-Subtitle__Typography">
          Autónomo
        </Typography>
        <div className="Ingresos_Input">
          <TextField
            value={facturacion}
            onChange={onStatusChangeFacturacion}
            className="Ingresos__TextField Ingresos__TextField--Facturacion"
            id="standard-textarea"
            placeholder="Facturación Bruta Mensual"
            type="number"
          />
        </div>

      </div>
    </div>
  );
};

export default Ingresos;
